<h1 mat-dialog-title>Non Disclosure Agreement
    <!-- Terms & Conditions -->
    <button mat-icon-button color="primary" class="subcSend" type="button" (click)="close(false)">
        <mat-icon>close</mat-icon>
    </button>
</h1>
<div mat-dialog-content class="scroller">
    <p>A manufacturing legal document is a contract between a manufacturer and a customer that outlines the terms and
        conditions for the manufacturing of goods. It is a legally binding document that protects the rights of both
        parties and helps to avoid disputes.</p>

    <p>Manufacturing legal documents can be very complex and vary depending on the specific needs of the parties
        involved. However, there are some key elements that are typically included in most manufacturing legal
        documents, such as:</p>
    <ul class="list-disc">
        <li><strong>The parties involved:</strong> The names and addresses of the manufacturer and the customer must be
            clearly stated in the document.</li>
        <li><strong>The products to be manufactured:</strong> The document should clearly describe the products that the
            manufacturer is agreeing to produce. This may include specifications such as the type of materials to be
            used, the dimensions of the products, and any other relevant details.</li>
        <li><strong>The quantity of products to be manufactured:</strong> The number of products that the manufacturer
            is agreeing to produce must be clearly stated in the document.</li>
        <li><strong>The price of the products:</strong> The price that the customer will pay for the products must be
            clearly stated in the document.</li>
        <li><strong>The delivery schedule:</strong> The document should specify when and where the products will be
            delivered to the customer.</li>
        <li><strong>Payment terms:</strong> The document should specify when and how the customer will pay the
            manufacturer for the products.</li>
        <li><strong>Intellectual property rights:</strong> The document should clearly state who owns the intellectual
            property rights to the products being manufactured. This may include patents, trademarks, and copyrights.
        </li>
    </ul>
</div>
<div mat-dialog-actions>
    <button mat-button class="btnCustom btn-primary" (click)="close(true)" *ngIf="!isActivenonDisclosureAgreement">I
        accept</button>
    <button mat-button (click)="close(false)">Close</button>
</div>